import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { cellValueClass, tableCellTextFormat } from '~/utils/table-helper';
import { Data } from '~/utils';
import { formatToDecimals } from '~/utils/number-helper';
import { PuiTableVendorOptions } from '~/models/libraries/pebble-ui';
import { GetMiniFdByGlobalIdResponse } from '~/models/services/minifd';

interface CompensationTotals {
    mtpYearPlus1Total: number;
}

@Component({})
export default class ViewCompensationTableComponent extends Vue {
    @Prop()
    private iybrData?: GetMiniFdByGlobalIdResponse;
    private cellValueClass = cellValueClass;
    private tableCellTextFormat = tableCellTextFormat;

    private get columns(): Record<string, string> {
        const selectedMtpYear = this.iybrData?.budgetCompensations[0].selectedMtpYear ?? 0;
        const firstHorizonYear = selectedMtpYear + 1;

        return {
            globalId: 'Global ID',
            projectName: 'Project Name',
            justification: 'Justification',
            originalMtp: `Original ${firstHorizonYear}`,
            compensated: `Compensated ${firstHorizonYear}`,
            newMtp: `New ${firstHorizonYear}`,
        };
    }

    private get formTotals(): CompensationTotals {
        let mtpYearPlus1Total = 0;

        this.iybrData?.budgetCompensations?.forEach(budgetCompensation => {
            mtpYearPlus1Total += budgetCompensation.requestedYearPlus1 ?? 0;
        });

        return {
            mtpYearPlus1Total,
        };
    }

    private get tableOptions(): PuiTableVendorOptions {
        const budgetCompensationRows = this.iybrData?.budgetCompensations?.map(entry => ({
            [this.columns.globalId]: entry.globalId,
            [this.columns.projectName]: entry.projectName,
            [this.columns.justification]: this.getValueForConstant('justificationTypes', entry.justification),
            [this.columns.originalMtp]: entry.original1.toString(),
            [this.columns.compensated]: formatToDecimals(entry.requestedYearPlus1, 3).toString(),
            [this.columns.newMtp]: formatToDecimals(entry.yearPlus1, 3).toString(),
        })) ?? [];

        const totalsRow = {
            [this.columns.globalId]: 'Total budget made available for the project whose approval is required',
            [this.columns.compensated]: this.formTotals.mtpYearPlus1Total,
        };

        return {
            data: [
                ...budgetCompensationRows,
                totalsRow
            ],
            options: {
                sortable: []
            },
            columns: Object.values(this.columns)
        };
    }

    private getValueForConstant(constantType: string, index?: string | number): string {
        if (!index) {
            return 'N/A';
        }

        const constantValue = Data.Instance.constants[constantType][index];

        if (!constantValue) {
            return 'Unknown';
        }

        return constantValue;
    }
}
